import { useMemo, useState } from "react"
import { ComboboxField } from "@ui/forms"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { useFetchBusinesses } from "@/hooks/api/businesses"

interface BusinessSelectorFieldProps<T extends FieldValues> {
  field: ControllerRenderProps<T, Path<T>>
  label?: string
  placeholder?: string
  currentBusinessId?: string
  bookIdOverride?: string
}

export function BusinessSelectorField<T extends FieldValues>({
  field,
  label = "Business",
  placeholder = "Select business",
  currentBusinessId,
  bookIdOverride,
}: BusinessSelectorFieldProps<T>) {
  const [searchQuery, setSearchQuery] = useState("")
  const { data: businesses, isLoading } = useFetchBusinesses(searchQuery, bookIdOverride)

  const options = useMemo(
    () =>
      businesses?.businesses
        ?.filter((business) => business.id !== currentBusinessId)
        .map((business) => ({ value: business.id, label: business.name || "Unnamed business" })) ?? [],
    [businesses?.businesses, currentBusinessId]
  )

  return (
    <ComboboxField
      id="business_id"
      label={label}
      field={field}
      onSearch={setSearchQuery}
      options={options}
      isSearching={isLoading}
      placeholder={isLoading ? "Loading..." : placeholder}
    />
  )
}
